/**
 * Minimal axios-compatible client for the put/get patterns used in this app.
 */

async function request(method, url, data, config = {}) {
  const headers = { ...(config.headers || { }) }
  const init = {
    method,
    headers,
    body: data === undefined ? undefined : data,
  }

  const res = await fetch(url, init)
  if (!res.ok) {
    const error = new Error(`Request failed with status ${res.status}`)
    error.response = { status: res.status, statusText: res.statusText }
    throw error
  }

  let responseData
  if (config.responseType === 'blob') {
    responseData = await res.blob()
  } else if (config.responseType === 'arraybuffer') {
    responseData = await res.arrayBuffer()
  } else if (config.responseType === 'text') {
    responseData = await res.text()
  } else {
    const text = await res.text()
    try {
      responseData = text ? JSON.parse(text) : null
    } catch {
      responseData = text
    }
  }

  return {
    data: responseData,
    status: res.status,
    statusText: res.statusText,
    headers: Object.fromEntries(res.headers.entries()),
    config,
  }
}

const axios = {
  get(url, config) {
    return request('GET', url, undefined, config)
  },
  put(url, data, config) {
    return request('PUT', url, data, config)
  },
  post(url, data, config) {
    return request('POST', url, data, config)
  },
  delete(url, config) {
    return request('DELETE', url, undefined, config)
  },
  request(config = {}) {
    const method = (config.method || 'get').toUpperCase()
    return request(method, config.url, config.data, config)
  },
}

export default axios
